import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Filter } from '@pages/User/JobsListPage/components/Content/components/JobsListDateFilter';
import { useModalContext } from '@providers/ModalProvider';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const JobsListFiltersModal = ({ onCancel, dateFilter, setDateFilter }: TProps) => {
  const { closeModal } = useModalContext();

  return (
    <ModalWrapper width="400px" onCancel={onCancel}>
      <ModalTitle>Filters</ModalTitle>
      <Content>
        <Filter hideHeader filter={dateFilter} setFilter={setDateFilter} close={closeModal} />
      </Content>
    </ModalWrapper>
  );
};
